import React from "react";
import useStaticDestinationsData from "components/StaticQuery/useStaticDestinationsData";
import {
  MosaicLayout,
  MosaicLayoutProps
} from "@silversea-ssc/ui-components-react";
import DestinationCard from "../Card/DestinationCard";

interface DestinationsMosaicProps extends MosaicLayoutProps {
  showExpeditionsOnly?: boolean;
}

const DestinationsMosaic: React.FC<DestinationsMosaicProps> = ({
  showExpeditionsOnly = false,
  ...props
}) => {
  const destinations = useStaticDestinationsData({
    showExpeditionsOnly
  });
  return (
    <MosaicLayout {...props} data-content-name="destinations_mosaic">
      {destinations.map((item) => (
        <DestinationCard
          key={item._id}
          title={item.card?.title?.localized || ""}
          image={item.card?.image}
          destinationId={item.destinationId}
          url={item.fullPath}
        />
      ))}
    </MosaicLayout>
  );
};

export default DestinationsMosaic;
